import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

import type React from "react";

type NavPortalProps = {
  children: React.ReactNode;
  containerId?: string;
};

export const NavPortal = ({ children, containerId = "navbar-portal-container" }: NavPortalProps) => {
  const ref = useRef<HTMLElement | null>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    ref.current = document.querySelector(`#${containerId}`);
    setMounted(true);
  }, [containerId]);

  return mounted && ref.current ? createPortal(children, ref.current) : null;
};
